import { render, staticRenderFns } from "./TimetableList.vue?vue&type=template&id=fa5b68c8"
import script from "./TimetableList.vue?vue&type=script&lang=ts"
export * from "./TimetableList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports